import { StyleLayer } from '../style_layer';
import properties from './background_style_layer_properties.g';
export class BackgroundStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
}
//# sourceMappingURL=background_style_layer.js.map